import React from 'react';
// components
import { TextComponent } from '../../../components/text';
// helpers/constants
import * as G from '../../../helpers';
// utilities
import routeMap from '../../../utilities/routes';
// ui
import { RelativeFlex, MainActionButton } from '../../../ui';
//////////////////////////////////////////////////

export const FooterComponent = ({ actionHide, totalCount, unreadCount }) => {
  const countTitle = `${unreadCount} of ${totalCount}`;

  const handleViewAll = (e) => {
    actionHide(e);

    G.goToRoute(routeMap.notificationList);
  };

  return (
    <RelativeFlex py={18} width='100%' justifyContent='center'>
      <MainActionButton
        height='auto'
        fontWeight={600}
        borderRadius={10}
        border='1px solid'
        onClick={handleViewAll}
        color={G.getTheme('colors.dark.mainDark')}
        borderColor={G.getTheme('colors.borderGray')}
      >
        {G.getWindowLocale('actions:view-all-notifications', 'View all notifications')}
      </MainActionButton>
      <TextComponent
        right={15}
        maxWidth={200}
        display='block'
        title={countTitle}
        withEllipsis={true}
        position='absolute'
        color={G.getTheme('colors.light.darkGrey')}
      >
        {countTitle}
      </TextComponent>
    </RelativeFlex>
  );
};
